module.exports = __webpack_public_path__ + "img/icon5.b4d61d88.svg";